module.exports = __webpack_public_path__ + "img/100.40bd704b.jpg";